import React, {useState, useEffect, useContext, ChangeEvent} from "react";

import {
  UnorderedList,
  ListItem,
  Container, Button, VStack,
  HStack,
  CheckboxGroup,
  Checkbox, useCheckboxGroup, Divider,
  Textarea,
  Select,
  Text,
  Box,
  Spacer,
  Table,
  Tr,
  Td,
  Img,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,

  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,

  SimpleGrid,
  Image,
  IconButton,

} from '@chakra-ui/react';
import {useNavigate,useParams} from "react-router-dom";
import {client, baseUrl} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";

import {
    MdSettings,
} from "react-icons/md";

import { EditIcon } from '@chakra-ui/icons';


import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"



import {WorkComponent} from "@/components/ItemComponent"
import { Work } from "@/pbgen/v1/main_pb";
import { Courseware, User } from "@/pbgen/v1/main_pb";
import { Directory } from "@/pbgen/v1/main_pb";


import './Works.css';
import './Coursewares.css';

const mainColor = '#df6694'

const chrImages = [
    'chr00',
    'chr01',
    'chr02',
    'chr03',
    'chr04',
    'chr05',
];

export const Works = () => {
  const [items, setItems] = useState<Work[]>([]);
  const [status, setStatus] = useState("");
  const [currentUser, setCurrentUser] = useState("")
  const { sid } = useParams();
  const [student, setStudent] = useState<User>(new User());
  const [vendor, setVendor] = useState<string>("")
  const [schoolroom, setSchoolroom] = useState<string>("")
  const [nameText, setNameText] = useState<string>("")
  const [privUser, setPrivUser] = useState<boolean>(false)
  const [medals, setMedals] = useState<string[]>([]);


  const {globalState, setGlobalState} = useContext(GlobalContext);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [imageSelected, setImageSelected] = useState<string>("");

 


  useEffect(() => {
    console.log(sid);
    (async () => {
      const resp = await client.getWorks({
        bearerToken: bearerToken(),
        userId: sid ?? "",
      });
      console.log(resp);
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})

      setCurrentUser(resp.currentUser?.optName ?? "")
      console.log(resp.works);

      setItems(resp.works);

      const medalsList = resp.works
        .filter((item) =>
          item.status === "completed" &&
          item.medal !== undefined &&
          item.medal !== null &&
          item.medal !== ''
        )
        .map((item) => item.medal);

      //console.log(medalsList);
      setMedals(medalsList);

      const studentId = sid ?? resp.currentUser?.id ?? ""
      setPrivUser(resp.currentUser?.optRole !== "student")

      const resp2 = await client.getUser({
        bearerToken: bearerToken(),
        id: studentId,
      });
      
      setStudent(resp2.user ?? new User());
      //console.log(resp2.user);
      setVendor(resp2.optVendorName ?? "")
      setSchoolroom(resp2.optSchoolroomName ?? "")

      if (resp2.user) {

        var name = resp2.user.optFamilyName
        if (resp2.user.optName) {
          name = name + "　" + resp2.user.optName
        }
        //console.log(name);
        var kana = resp2.user.optFamilyNamePronunciation
        if (resp2.user.optNamePronunciation) {
          kana = kana + "　" + resp2.user.optNamePronunciation
        }
        //console.log(kana);
        if (kana !== "") {
          name = name + "　(" + kana + ")"
        }
        //console.log(name);
        setNameText(name ?? "")
        //console.log(nameText);

        setImageSelected(resp2.user.optImageId || "chr00")
        console.log("imageSelected:", resp2.user.optImageId);
        console.log("imageSelected2:", imageSelected);
      }

    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const navigate = useNavigate();
  const logout = () => {
    navigate("/logout")
  }

  const handleImageSelect = (src: string) => {
    setImageSelected(src);
    //console.log(src);
    const resp = client.updateUserImage({
      bearerToken: bearerToken(),
      id: student.id ?? "",
      imageId: src,
    });
    onClose();
  };


  const onDelete = async () => {
    const resp = await client.getWorks({
      bearerToken: bearerToken(),
      userId: sid ?? "",
    });
    setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})
    setCurrentUser(resp.currentUser?.optName ?? "")
    setItems(resp.works);
};
  return <Page>
    {globalState.currentUser?.optRole !== "student" &&
    <PageHeader title={"教材リスト"}>
      {
        (privUser)? (
          <HStack padding={2}>
            <Button onClick={() => {navigate("./add", {relative: "path"})}}>教材の追加</Button>
            <Button onClick={() => {navigate("../..", {relative: "path"})}}>戻る</Button>
            {/* <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button> */}
          </HStack>
        ) : (
          <Button onClick={() => {navigate("/logout", {relative: "path"})}}>もどる</Button>
        )
      }
    </PageHeader>
    }
    <PageBody>
      <VStack spacing={2} align="start">

        <HStack className="works_top_block" justify="space-between">

{/*
          <VStack className="works_icon_block" align="center" spacing={0}></VStack>
*/}

          <VStack className="works_name_vstack" align="start" spacing={0}>

            <HStack>

              {imageSelected && (
                <Box position="relative" w="140px" h="140px" marginRight={2}>
                  <Image src={`/ap/img/${imageSelected}.png`}
                      alt="キャラクター"
                      objectFit="cover"
                      w="100%" h="100%" 
                      borderRadius="md"
                    />
                    <IconButton
                      icon={<MdSettings />}
                      aria-label="えらぶ"
                      position="absolute"
                      bottom="1"
                      right="1"
                      size="xs"
                      colorScheme="teal"
                      onClick={onOpen}
                    />
                </Box>
              )}

              <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
                <ModalOverlay />
                <ModalContent w="fit-content" minW="auto" maxW="unset" >
                  <ModalHeader>キャラクターをえらぼう</ModalHeader>
                  <ModalCloseButton />
                  <ModalBody>
                    <SimpleGrid columns={[2, 3]} spacing={2}>
                    {chrImages.map((src) => (
                      <Box
                        key={src}
                        w="fit-content"
                        h="fit-content"
                        border={imageSelected === src ? '3px solid #ff0000' : '1px solid #ccc'}
                        borderRadius="md"
                        overflow="hidden"
                        cursor="pointer"
                        onClick={() => handleImageSelect(src)}
                        transition="all 0.2s"
                        _hover={{ borderColor: '#3182ce' }}
                      >
                        <Image src={`/ap/img/${src}.png`} alt={src} boxSize="80px" objectFit="contain" />
                    </Box>
                    ))}
                    </SimpleGrid>
                  </ModalBody>
                </ModalContent>
              </Modal>

              <VStack align="start">

                {(vendor === null || vendor === undefined || vendor === "") ? 
                  '' : <Text className="works_class_text" >{vendor}</Text>}

                {(schoolroom === null || schoolroom === undefined || schoolroom === "") ? 
                  '' : <Text className="works_class_text" >教室 : {schoolroom}</Text>}

                {(student.optCourse === null || student.optCourse === undefined || student.optCourse === "") ? 
                  '' : <Text className="works_class_text" >コース : {student.optCourse}</Text>}

                {(nameText === null || nameText === undefined || nameText === "") ? 
                  '' : <Text className="works_name_text" >{nameText}</Text>}
  
              </VStack>

            </HStack>

          </VStack>

          {globalState.currentUser?.optRole === "student" && <Button className="works_endbutton" onClick={logout}>おわる</Button>}

        </HStack>

        <Box p={2}>
          <SimpleGrid columns={[4, 8, 10, 10]} spacing={2}>
            {medals.map((medal, index) => (
              <Image
                key={index}
                src={`${baseUrl}/scratch_api/assets/${medal}`}
                alt={`medal-${index}`}
                boxSize="64px"
                objectFit="cover"
                borderRadius="md"
                boxShadow="sm"
              />
            ))}
          </SimpleGrid>
        </Box>

        {
          items.map((item) => 
            <WorkComponent 
              key={item.eid} 
              item={item} 
              privUser={privUser} 
              mainColor={mainColor} 
              bearerToken={bearerToken} 
              navigate={navigate} 
              onDelete={onDelete}
            />
          )
        }

        </VStack>
    </PageBody>
  </Page>
}

//               <li><Checkbox value={item.id}>{f.base}</Checkbox></li>

function drawAddTable(root: Directory, navigate: any, existingWorks: number[]) {
  return (

    <Table className="coursewares_table"><tbody>
    {root.files.map((f) =>
      <Tr className="coursewares_table_item">
        <Td key={'td-${f.path.join("/")}'} p={2} m={0}>
          <Checkbox key={'checkbox-${f.path.join("/")}'} isDisabled={existingWorks.includes(f.optCourseware?.id || 0)} value={f.optCourseware?.id}>
          <HStack>
            <Img className="coursewares_table_thumbnail" src={`${baseUrl}/scratch_api/assets/${f.optCourseware?.thumbnailId}`} />
            <span dangerouslySetInnerHTML={{ __html: f.optCourseware?.title ?? '' }}></span>
            </HStack>
          </Checkbox>
        </Td>
      </Tr>
    )}
    {
      root.directories.map((d) =>
        <>
        <tr>
        <td colSpan={2} className="coursewares_table_label"><span>{d.base}</span></td></tr>
        <tr><td>{drawAddTable(d, navigate, existingWorks)}</td></tr>
        </>
      )
    }
    </tbody></Table>
  
  );
}

function drawAddTableOLD(root: Directory, navigate: any, existingWorks: number[]) {
  return (<Table className="coursewares_table">
    {root.files.map((f) =>
      <Tr className="coursewares_table_item">
        <Td key={f.path.join("/")} p={2} m={0}>
          <Checkbox isDisabled={existingWorks.includes(f.optCourseware?.id || 0)} value={f.optCourseware?.id}>
          <HStack>
            <Img className="coursewares_table_thumbnail" src={`${baseUrl}/scratch_api/assets/${f.optCourseware?.thumbnailId}`} />
            <span>{f.optCourseware?.title}</span>
          </HStack>
          </Checkbox>
        </Td>
      </Tr>
    )}
    {
      root.directories.map((d) =>
        <>
        <tr><td colSpan={2} className="coursewares_table_label"><span>{d.base}</span></td></tr>
          {drawAddTable(d, navigate, existingWorks)}
        </>
      )
    }
  </Table>);
}

function drawTree(root: Directory, navigate: any, existingWorks: number[]) {
  console.log("Drawn")
  return (<UnorderedList>
    {
      root.files.map((f) =>
        <ListItem key={f.path.join("/")}><Checkbox isDisabled={existingWorks.includes(f.optCourseware?.id || 0)} value={f.optCourseware?.id}>{f.base}</Checkbox></ListItem>
      )
    }
    {
      root.directories.map((d) =>
        <>
          <ListItem >{d.base}</ListItem>
          {drawTree(d, navigate, existingWorks)}
        </>
      )
    }
  </UnorderedList>);
}


export const AddWorks = () => {
  const [root, setRoot] = useState<Directory>(new Directory());
  const [status, setStatus] = useState("");
  const [saveError, setSaveError] = useState("");
  const [currentUser, setCurrentUser] = useState("")
  const [ventorId, setVentorId] = useState("")
  const { sid } = useParams();
  const [selectedWorks, setSelectedWorks] = useState<number[]>([])
  const [existingWorks, setExistingWorks] = useState<number[]>([])
  const { isOpen: isErrorOpen, onOpen: onErrorOpen, onClose: onErrorClose } = useDisclosure()
  const { isOpen: isFinishOpen, onOpen: onFinishOpen, onClose: onFinishClose } = useDisclosure()

  const {globalState, setGlobalState} = useContext(GlobalContext);
  useEffect(() => {
    (async () => {

      console.log("34618931", currentUser);

      const resp = await client.getCoursewareTree({
        bearerToken: bearerToken(),
        userId: sid,
      });
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})


      console.log("34435325", resp);

      setCurrentUser(resp.currentUser?.optName ?? "")
      setVentorId(resp.currentUser?.optVendorId ?? "")
      setRoot(resp.root ?? new Directory())

      const resp2 = await client.getWorks({
        bearerToken: bearerToken(),
        userId: sid,
      });
      setExistingWorks(resp2.works.map((work) => work.coursewareId))
      setSelectedWorks(resp2.works.map((work) => work.coursewareId))
    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const navigate = useNavigate();

  console.log("655777f", existingWorks, root);

  const save = async () => {
    const resp = await client.addWorks({
      bearerToken: bearerToken(),
      studentId: sid,
      coursewareIds: selectedWorks,
    });
    if (resp.error) {
      setSaveError(resp.error.message);
      onErrorOpen();
      return
    } else {
      onFinishOpen();
    }
    setExistingWorks(selectedWorks);
  }

  const handleOk = () => {
    navigate(-1);
  };

  const drawTabs = (VendorId: string) => {
    return (
      <Box>
        <Tabs variant="enclosed-colored">
          {/* タブリスト */}
          <TabList>
          {
            root.directories.map((d) =>
              <>
              <Tab key={'tab-${d.id}'}
                sx={{
                  border: '1px #df6694 solid',
                  background: 'white',
                  _selected : { color: 'white', bg: '#df6694' },
                  _hover : { bg: '#fdcbde' },
                }}
              >
                {(d.base === VendorId) ? "教材" : d.base}
              </Tab>
              </>
            )
          }
          </TabList>
  
          {/* タブのコンテンツ */}
          <TabPanels>
          {
            root.directories.map((d) =>
              <>
              <TabPanel p={0} key={'tabpanel-${d.id}'}>
  
                <CheckboxGroup key={'checkboxgrp-${d.id}-${existingWorks.join(",")}'} value={selectedWorks} onChange={
                  (selectedValues) => {
                    setSelectedWorks(selectedValues.map(n => Number(n)));
                    console.log("c19c168", selectedValues);
                  }
                }>

                  {drawAddTable(d, navigate, existingWorks)}
  
                </CheckboxGroup>
  
              </TabPanel>
              </>
            )
          }
          </TabPanels>
        </Tabs>
      </Box>
    );
  };

  return <Page>
    <PageHeader title={"教材追加"}>
      <HStack padding={2}>
        <Button onClick={save}>保存</Button>
        {/* <Button onClick={() => {navigate("..", { relative: "path" })}}>戻る</Button> */}
        <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>
      </HStack>
    </PageHeader>

    <PageBody>
      <VStack>
        {drawTabs(ventorId)
            /*  drawAddTable(root, navigate, existingWorks) */
        }
      </VStack>

      <VStack>
        <Modal isOpen={isFinishOpen} onClose={onFinishClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>保存</ModalHeader>
            <ModalCloseButton />
            <ModalBody>教材情報を保存しました。</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={handleOk}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <Modal isOpen={isErrorOpen} onClose={onErrorClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Error</ModalHeader>
            <ModalCloseButton />
            <ModalBody>{saveError}</ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={onErrorClose}>OK</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

      </VStack>
    </PageBody>
  </Page>
}
